import type { ReactNode } from 'react'
import { BriefingStepItem } from '@/shared/briefing'
import type { ComponentRohsBriefingStep } from '@/shared/briefing/buildComponentRohsBriefing'
import { V2_COMPONENT_ROHS_BRIEFING_ID_PREFIX } from './constants'

export function V2ComponentRohsBriefingStepShell({
  step,
  index,
  actions,
  children,
}: {
  step: ComponentRohsBriefingStep
  index: number
  actions?: ReactNode
  children?: ReactNode
}) {
  return (
    <BriefingStepItem
      idPrefix={V2_COMPONENT_ROHS_BRIEFING_ID_PREFIX}
      index={index}
      step={step}
      actions={actions}
    >
      {children}
    </BriefingStepItem>
  )
}
